<template>
  <div>
    <dx-description-label v-if="$te(`${translationKeyPrefix}.description`)">
      {{ $t(`${translationKeyPrefix}.description`) }}
    </dx-description-label>

    <dx-input
      :id="config.id"
      :value="internalValue"
      :label="translatedLabel"
      type="date"
      :disabled="config.readonly"
      :error="translatedError"
      @input="update"
      @complete="complete"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { DxInput } from '@sumcumo/dextra-frontend-component-lib'
import DxDescriptionLabel from '~/components/DX-DescriptionLabel/DxDescriptionLabel'

function scipDateToDextraDate(dateString) {
  if (!dateString) {
    return ''
  }
  const date = moment(dateString, 'YYYY-MM-DD')
  return date.isValid() ? date.format('DD.MM.YYYY') : ''
}

function dextraDateToScipDate(dateString) {
  if (!dateString) {
    return null
  }
  const date = moment(dateString, 'D.M.YYYY')
  return date.isValid() ? date.format('YYYY-MM-DD') : null
}

function convertDate(date) {
  return date instanceof Date ? moment(date).format('DD.MM.YYYY') : date
}

export default {
  name: 'DXDateInputAdapter',
  components: {
    DxDescriptionLabel,
    DxInput,
  },
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: 'text',
    },
    value: {
      type: [Date, String],
      default: null,
    },
    error: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      internalValue: scipDateToDextraDate(this.value),
    }
  },
  computed: {
    translationKeyPrefix() {
      if (this.config.source) {
        if (this.config.source.kind === 'values') {
          return `attributes.${this.config.source.key}.${this.config.source.originalId}`
        }

        return `${this.config.source.key}.${this.config.source.originalId}`
      }

      return ''
    },

    translatedLabel() {
      return this.$t(`${this.translationKeyPrefix}.label`)
    },

    translatedError() {
      return this.error
        ? this.$t(`errors.date.${this.error.type}`, {
            ...this.error.params,
            label: this.translatedLabel,
            min: convertDate(this.error.params.min),
            max: convertDate(this.error.params.max),
          })
        : null
    },
  },
  watch: {
    value: {
      handler(newValue) {
        this.internalValue = scipDateToDextraDate(newValue)
      },
    },
  },
  methods: {
    update(internalValue) {
      this.internalValue = internalValue
    },
    complete() {
      const value = dextraDateToScipDate(this.internalValue)
      this.$emit('input', value)
      this.internalValue = scipDateToDextraDate(value)
      this.$emit('validate', this.config.id)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@sumcumo/dextra-frontend-component-lib/dist/assets/styles/variables/colors';
@import '~@sumcumo/dextra-frontend-component-lib/dist/assets/styles/variables/typo';
@import '~@sumcumo/dextra-frontend-component-lib/dist/assets/styles/functions/px-to-rem';

.label {
  display: block;
  color: $black-clr;
  font-family: $font-family-heavy;
  font-size: rem(20);
  line-height: rem(28);
}
</style>
